// @flow
import React from "react";
import { Link, useRouteMatch } from "react-router-dom";
import {
  Container,
  Dropdown,
  Icon,
  Image,
  Menu,
  Responsive,
  Sidebar,
} from "semantic-ui-react";
import styled from "styled-components";

import analytics from "../../utils/analytics";
import ThemeContext from "../../context/theme";
import "./TopBar.css";

type Props = {
  children: React.Node,
};

const logoSrc = `${process.env.PUBLIC_URL}/images/logo.png`;

const ContainerStyles = styled.div`
  height: 100vh;
  padding-top: 60px;
`;

const LogoStyles = {
  maxWidth: "64px",
  paddingLeft: "0",
};

const NavigationStyles = {
  borderRadius: "0",
  borderWidth: "0",
  boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.05)",
  padding: "0 1rem",
};

const DesktopTopBar = (props: Props) => {
  const { children } = props;
  const { isDark } = React.useContext(ThemeContext);

  const trackNavigationEvents = ({ action, label }) => {
    analytics.sendEvent({
      category: "Navigation",
      action,
      label,
    });
  };

  return (
    <Responsive minWidth={768}>
      <Menu borderless fixed="top" inverted={isDark} style={NavigationStyles}>
        <Container>
          <Menu.Item
            style={LogoStyles}
            onClick={() =>
              trackNavigationEvents({ action: "Clicked Menu", label: "Logo" })}
          >
            <Link to="/">
              <Image alt="CRM Petugas" src={logoSrc} />
            </Link>
          </Menu.Item>
          <Menu.Menu position="right">
            <Menu.Item
              as={Link}
              active={useRouteMatch("/report/:id")}
              onClick={() =>
                trackNavigationEvents({
                  action: "Clicked Menu",
                  label: "Lacak Aduan",
                })}
              to="/"
            >
              Lacak Aduan
            </Menu.Item>
            {/* <Menu.Item
              as={Link}
              active={useRouteMatch("/stats")}
              onClick={() =>
                trackNavigationEvents({
                  action: "Clicked Menu",
                  label: "Statistik",
                })}
              to="/stats"
            >
              Statistik
            </Menu.Item> */}
            <Dropdown
              text="Pengaturan"
              pointing
              className="link item"
              onClick={() =>
                trackNavigationEvents({
                  action: "Clicked Dropdown",
                  label: "Pengaturan",
                })}
            >
              <Dropdown.Menu>
                <Dropdown.Item
                  as={Link}
                  to="/settings/themes"
                  onClick={() =>
                    trackNavigationEvents({
                      action: "Clicked Sub Menu",
                      label: "Tema",
                    })}
                >
                  <Icon name="paint brush" />
                  Tema
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Menu.Menu>
        </Container>
      </Menu>
      {children}
    </Responsive>
  );
};

const MobileTopBar = (props: Props) => {
  const { children } = props;
  const { isDark } = React.useContext(ThemeContext);
  const [sidebarHide, setSidebarHide] = React.useState(false);

  const closeSidebar = () => {
    setSidebarHide(false);
  };

  const toggleSidebar = () => {
    setSidebarHide(!sidebarHide);
  };

  return (
    <Responsive maxWidth={767}>
      <Sidebar.Pushable>
        <Sidebar
          as={Menu}
          animation="overlay"
          inverted={isDark}
          onHide={closeSidebar}
          vertical
          visible={sidebarHide}
        >
          <Menu.Item onClick={closeSidebar}>
            <Icon name="close" />
            Tutup
          </Menu.Item>
          <Menu.Item as={Link} onClick={closeSidebar} to="/">
            <strong>Lacak Aduan</strong>
          </Menu.Item>
          <Menu.Item as={Link} onClick={closeSidebar} to="/stats">
            <strong>Statistik</strong>
          </Menu.Item>
          <Menu.Item as={Link} onClick={closeSidebar} to="/settings/themes">
            <strong>Pengaturan Tema</strong>
          </Menu.Item>
        </Sidebar>

        <Sidebar.Pusher dimmed={sidebarHide}>
          <Container>
            <Menu borderless inverted={isDark} secondary size="large">
              <Menu.Item onClick={toggleSidebar} className="topbar-burger-btn">
                <Icon name="sidebar" style={{ margin: "0 !important" }} />
              </Menu.Item>
              <Menu.Item position="right" style={LogoStyles}>
                <Link to="/">
                  <Image alt="CRM Petugas" src={logoSrc} />
                </Link>
              </Menu.Item>
            </Menu>
          </Container>
          {children}
        </Sidebar.Pusher>
      </Sidebar.Pushable>
    </Responsive>
  );
};

const TopBar = (props: Props) => {
  const { children } = props;

  return (
    <>
      <DesktopTopBar>
        <ContainerStyles>{children}</ContainerStyles>
      </DesktopTopBar>
      <MobileTopBar>{children}</MobileTopBar>
    </>
  );
};

export default React.memo<Props>(TopBar);
